const setores = {
  NDI: 'NDI',
  NOT: 'NOT',
  NAJ: 'NAJ',
  CAF: 'CAF',
  GAB: 'GAB',
  NUTIT: 'NUTIT',
  ARQUIVO: 'ARQUIVO',
  PGE: 'PGE',
  TECNICO_DE_CAMPO: 'TECNICO_DE_CAMPO'
}

const setoresFormatado = {
  NDI: 'NDI',
  NOT: 'NOT',
  NAJ: 'NAJ',
  CAF: 'CAF',
  GAB: 'GAB',
  NUTIT: 'NUTIT',
  ARQUIVO: 'Arquivo',
  PGE: 'PGE'
}

export const nomesSetores = {
  NDI: 'Núcleo de distribuição e Informação',
  NOT: 'Núcleo de Operações técnicas',
  NAJ: 'Núcleo de Apoio Jurídico',
  CAF: 'Coordenação de ação Fundiária',
  GAB: 'Gabinete',
  NUTIT: 'Núcleo de titulação',
  ARQUIVO: 'Arquivo',
  PGE: 'Procuradoria Geral do Estado'
}

export const setoresInformacao = []

export const setoresOrigemInformacao = []

export default {
  setores,
  nomesSetores,
  setoresFormatado
}



// WEBPACK FOOTER //
// ./src/utils/ba/setor.js